import request from '~/utils/http';

export function getId(data) {
  return request({
    url: '/api/Captcha/GetId',
    method: 'post',
    data
  })
}
